import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { LocationService } from '../services/location.service';
import { AccentsUtils } from '../shared/accents-utils.service';
import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { AppSettings } from '../settings/app.settings';
import { SEOService } from '../shared/seo-service';



///  <reference path="../../../../node_modules/@types/jquery/index.d.ts"/>

@Component({
  styleUrls: ['./all-destination.component.scss'],
  selector: 'all-destination',
  templateUrl: './all-destination.component.html',
  encapsulation: ViewEncapsulation.Emulated
})
export class AllDestinationComponent implements OnInit{
    public destinationObject:Country[];
    public alphabet:string[];
    public continentID:number;
    public countryName:string;
    public countriesSelect:string[];
    constructor(private locationService:LocationService, private router:Router, private route:ActivatedRoute,
        private meta:Meta, private translate:TranslateService, private accentsUtils:AccentsUtils, private title:Title,
        private seoService:SEOService, private hlang:HrefLang){}

    public ngOnInit(){
        this.translate.get("META_TITLE_DESTINATIONS").subscribe(text=>{
            this.title.setTitle(text);
        });
        this.translate.get("META_DESC_DESTINATIONS").subscribe(text=>{
            let tag:MetaDefinition = {
                name:"description",
                content:text
            };
            this.meta.addTags([tag]);
        });

        let langs = [
            {lang:'es',text:'destinos'},            
            {lang:'en',text:'destinations'}/*,
            {lang:'fr',text:'destinations'},
            {lang:'it',text:'destinazioni'},
            {lang:'de',text:'reiseziele'} */
        ];
        langs.forEach(lang => {
        let hreflang_:HrefLangDefinition = {
            rel: "alternate",
            href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
            hreflang: `${lang.lang}`
        }
        this.hlang.addTags([hreflang_]);
        }); 
        
        this.route.params
        .subscribe(params => {
            this.initFunction();
        });
    } 

    private initFunction(){
        this.getAllLocations();
        this.createLinkForCanonicalURL();
    }
    
    createLinkForCanonicalURL() {
        this.seoService.createLinkForCanonicalURL('');
    }

    /**
     * Se recibe y trata los datos de ALL_LOCATIONS
     */
    private getAllLocations(){
        this.destinationObject = [];
        this.alphabet = [];
        this.countriesSelect = [];
        this.continentID = 0;

        /**
         * Se crea y guarda los objectos Country y la primera letra de cada pais
         */
        this.locationService.findAllLocations().subscribe(res => {
            res.map(continent => {
                continent.countries.map(c => {
                    this.destinationObject.push(new Country(continent.continent.id,c.country.name,c.locations,this.removeAccents(c.country.name[0])));
                    this.alphabet.push(this.removeAccents(c.country.name[0]).toLowerCase());
                });
            });
            /**
             * Ordenado segun el nombre de las ciudades y luego por cada pais
             */
            this.destinationObject.sort((a,b) => {return (a.countryName > b.countryName) ? 1 : ((b.countryName > a.countryName) ? -1 : 0)})
                .map(el => {
                    this.countriesSelect.push(el.countryName);
                    el.location.sort((a,b) => {return (a["name"] > b["name"]) ? 1 : ((b["name"] > a["name"]) ? -1 : 0)});
                });

            this.removeLetters();

        }, (error) => {
            this.router.navigate(['oops/'+error])
        });
    }

    /**
     * Crea el link de las ciudades
     * @param location nombre de la ciudad
     */
    public getUrl(location){
        let name = this.accentsUtils.transformUrl(location.name);
        return `../${location.id}/${name}`;
    }

    /**
     * Se filtra la lista dependiendo del continente escogido
     * @param event ID del continent
     */
    public sortByContinent(event) {
        if (this.continentID != event.target.value) {
            this.countriesSelect = [];
            if (event.target.value == 0) {
                this.showAll(event);
            } else {
                let holding = [];
                this.continentID = event.target.value;
                holding = this.destinationObject.filter(el => {
                    if (el.continentID == this.continentID) {
                        this.countriesSelect.push(el.countryName);
                        el["hidd"] = false;
                        return el;
                    } else {
                        el["hidd"] = true;
                    }
                });
                this.alphabet = [];
                holding.map(country => {
                    this.alphabet.push(country.countryName[0].toLowerCase());
                });
                this.removeLetters();
            }
        }
    }
    /**
     * Se marcan todos como visibles y se muestran todas las letras posibles
     * @param event ID continente 0, se devolvera todo
     */
    private showAll(event){
        this.continentID = 0;
        this.alphabet = [];
        this.destinationObject.map(country => {
            country["hidd"] = false;
            this.countriesSelect.push(country.countryName);
            this.alphabet.push(country.countryName[0].toLowerCase());
        });
        this.removeLetters();
    }

    /**
     * Mostraremos el pais segun el que se haya seleccionado
     * @param countryName nombre del pais
     */
    public changeCountry(countryName) {
        this.alphabet = [];
        if (countryName == -1) {
            this.destinationObject.map(el => { el["hidd"] = false; this.alphabet.push(el.countryName[0].toLowerCase()); })
        } else {
            this.countryName = countryName;
            this.destinationObject.map(el => {
                if (el.countryName === countryName) {
                    el["hidd"] = false;
                    this.alphabet.push(el.countryName[0].toLowerCase());
                } else {
                    el["hidd"] = true;
                }
            });
        }
        this.removeLetters();
    }

    /**
    * Elimino las letras repetidas
    */
    private removeLetters(){
        this.alphabet = this.alphabet.filter(function(elem, index, arr) {
            return index === arr.indexOf(elem);
        }).sort();
    }

    /**
     * Se utiliza porque hay paises que su primera letra esta acentuada
     * @param str String al que se le borraran los acentos
     */
    private removeAccents(str) {
        let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        str = str.split('');
        str.forEach((letter, index) => {
          let i = accents.indexOf(letter);
          if (i != -1) {
            str[index] = accentsOut[i];
          }
        })
        return str.join('');
      }
}

export class Country {
    constructor(public continentID:number,public countryName:string, public location:Array<string>, public firstLetter:string) {
        this.firstLetter = firstLetter.toLowerCase();
    }
}
